import { differenceInCalendarDays } from 'date-fns'

import { PRACTICE_ORDER_EDIT_LOOKBACK_DAYS } from '../../../utils/shouldShowPracticeOrder'
import type { SellerTutorialEvent } from '@/resources/types/seller'

export const PRACTICE_ORDER_EDIT_TOUR_ID = 'feature-practice-order-edit'

export const PRACTICE_ORDER_EDIT_TOUR_START_OPTIONS = {
  stepIndex: 0,
  viewedStepCount: 0,
} as const

export const PRACTICE_ORDER_EDIT_ORIENTATION_STEP_TARGET_ID =
  'edit-order-customer-preference-section'

export type IsPracticeOrderEditTourActiveInput = {
  activeTourId: string | null
  status: string
}

export const isPracticeOrderEditTourActive = ({
  activeTourId,
  status,
}: IsPracticeOrderEditTourActiveInput): boolean =>
  status === 'active' && activeTourId === PRACTICE_ORDER_EDIT_TOUR_ID

export type ShouldRenderPracticeOrderGuideTourButtonInput = {
  isGuideTourButtonVisible: boolean
} & IsPracticeOrderEditTourActiveInput

export const shouldRenderPracticeOrderGuideTourButton = ({
  isGuideTourButtonVisible,
  activeTourId,
  status,
}: ShouldRenderPracticeOrderGuideTourButtonInput): boolean =>
  isGuideTourButtonVisible &&
  !isPracticeOrderEditTourActive({ activeTourId, status })

export const getPracticeOrderEditOrientationStepIndex = ({
  steps,
}: {
  steps: readonly { targetId?: string }[]
}): number => {
  const index = steps.findIndex(
    step => step.targetId === PRACTICE_ORDER_EDIT_ORIENTATION_STEP_TARGET_ID
  )

  return Math.max(index, 0)
}

const parseTimestamp = (value: string | null | undefined): Date | null => {
  if (!value) {
    return null
  }

  const parsedDate = new Date(value)

  if (Number.isNaN(parsedDate.getTime())) {
    return null
  }

  return parsedDate
}

export type ShouldShowPracticeOrderGuideTourTooltipInput = {
  sellerOpenedEditModal?: SellerTutorialEvent
  now: Date
}

export const shouldShowPracticeOrderGuideTourTooltip = ({
  sellerOpenedEditModal,
  now,
}: ShouldShowPracticeOrderGuideTourTooltipInput): boolean => {
  if (sellerOpenedEditModal == null || sellerOpenedEditModal.count < 1) {
    return false
  }

  const occurredAt = parseTimestamp(sellerOpenedEditModal.lastUpdate)

  if (!occurredAt) {
    return false
  }

  const daysSinceOpened = differenceInCalendarDays(now, occurredAt)

  return (
    daysSinceOpened >= 0 && daysSinceOpened > PRACTICE_ORDER_EDIT_LOOKBACK_DAYS
  )
}
